export const
    APP_RESET = 'app_reset',
    APPS_RESET = 'apps_reset',
    APPS_PENDING = 'apps_pending',
    APP_FOCUS = 'app_focus',
    APP_DELETED = 'app_deleted',
    APP_POSTING = 'app_posting',
    APP_EDITING = 'app_editing',
    APP_DELETING = 'app_deleting',
    APP_FAILED = 'app_failed',
    APPS_FAILED = 'apps_failed',
    APP_DOWNLOADED = 'app_downloaded',
    APPS_DOWNLOADED = 'apps_downloaded',
    APP_PICTURE_UPLOADING = 'app_picture_uploading',
    APP_PICTURE_FAILED = 'app_picture_failed',
    APP_PICTURE_UPLOADED = 'app_picture_uploaded',
    APP_PICTURE_DELETING = 'app_picture_deleting',
    APP_PUSH_SUBSCRIBED = "app_push_subscribed",
    APP_PUSH_SUBSCRIBED_RESET = "app_push_subscribed_reset";



// WEBPACK FOOTER //
// src/store/apps/types.js